<div class="message-container" [ngClass]="{'message-danger': !msg.SUCCESS, 'message-success': msg.SUCCESS}">
	{{ msg.MSG }}
</div>